const unityViewerBuildUrl = `/Build`;

const useUnityDevBuild =
  (process.env.USE_UNITY_DEV_BUILD ?? "false") === "true";

const CONFIG = {
  // DEFAULT CONFIG
  O11Y_COLLECTOR_ENDPOINT: "https://faro-collector-prod-us-east-0.grafana.net/collect/59ecd762554cac92d7157e9ce99b3b16",
  GOOGLE_MAPS_API_KEY: "AIzaSyDocUUvCAiQo5zEuvRPkuG6HNIVsdgrhlc",
  UNITY_VIEWER_PROPS: {
    loaderUrl: `${unityViewerBuildUrl}/TexturedLoDs.loader.js`,
    dataUrl: `${unityViewerBuildUrl}/TexturedLoDs.data${
      useUnityDevBuild ? "" : ".unityweb"
    }`,
    frameworkUrl: `${unityViewerBuildUrl}/TexturedLoDs.framework.js${
      useUnityDevBuild ? "" : ".unityweb"
    }`,
    codeUrl: `${unityViewerBuildUrl}/TexturedLoDs.wasm${
      useUnityDevBuild ? "" : ".unityweb"
    }`,
    companyName: "Preimage",
    productName: "Preimage Virtual Tour Viewer",
    productVersion: "0.1",
    streamingAssetsUrl: "StreamingAssets",
    matchWebGLToCanvasSize: false,
  },
  DECOMPRESSION_FALLBACK_ENABLED: false,

  // ENVIRONMENT VARIABLES
  APP_URL: process.env.APP_URL,
  API_URL: process.env.API_URL,
  OUTPUTS_URL: process.env.OUTPUTS_URL,
  // client id is public, no issues publishing it
  APS_CLIENT_ID: process.env.APS_CLIENT_ID || "gtrgPf1mSYn9wZnwUNKYQBsDbVQnommm2rnppiiIQBasjMBp",
  VIEWER_URL: process.env.VIEWER_URL,
  VIEWER_V2_URL: process.env.VIEWER_V2_URL,
  AUTH0_DOMAIN: process.env.AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: process.env.AUTH0_CLIENT_ID,
  AUTH0_AUD: process.env.AUTH0_AUD,
  PAYMENTS_CHECKOUT_URL: process.env.PAYMENTS_CHECKOUT_URL,
  GOOGLE_ANALYTICS_TRACKING_ID: process.env.GOOGLE_ANALYTICS_TRACKING_ID,
  TRANSFERS_API_URL: process.env.TRANSFERS_API_URL,
  OPEN_ID_ROLE_ARN: process.env.OPEN_ID_ROLE_ARN,
  INPUTS_UPLOAD_BUCKET: process.env.INPUTS_UPLOAD_BUCKET,
  ROLES: {
    STAFF: process.env.ROLES_STAFF,
    TEAM: process.env.ROLES_TEAM,
  },
  MAPBOX_ACCESS_TOKEN: process.env.MAPBOX_ACCESS_TOKEN,
  MAPBOX_DEBOUNCE_TIME_INTERVAL: parseInt(
    process.env.MAPBOX_DEBOUNCE_TIME_INTERVAL || "5000"
  ), // default on local -> 5s
  MANUAL_URL: process.env.MANUAL_URL,
  RAZORPAY_KEY_ID: process.env.RAZORPAY_KEY_ID,
  RAZORPAY_PLANS: {
    ENTERPRISE: process.env.RAZORPAY_PLAN_ENTERPRISE,
    PROFESSIONAL: process.env.RAZORPAY_PLAN_PROFESSIONAL,
    STARTER: process.env.RAZORPAY_PLAN_STARTER,
    PAY_AS_YOU_GO: process.env.RAZORPAY_PLAN_PAY_AS_YOU_GO,
  },
  POSTHOG_KEY: process.env.REACT_APP_PUBLIC_POSTHOG_KEY,
  POSTHOG_HOST: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

if (process.env.REACT_APP_ENV === "local") {
  console.log(CONFIG);
}

export default CONFIG;
